import {Locales} from '@netx/core-next/locales/utils/Locales';

export const CartsSavedLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.savedCollections'),
	VIEW_ALL: i18n('i18n.viewAllCarts'),
}));

export const CartsSavedManagerLabel = Locales((i18n) => ({
	TITLE: i18n('i18n.name'),
}));

export const CartsSavedActionLabel = Locales((i18n) => ({
	SAVE: i18n('i18n.save'),
}));

export const CartsSavedMessage = Locales((i18n) => ({
	NO_RESULTS: i18n('i18n.emptySavedCollectionsSubtitle', {
		buttonHTML: i18n('i18n.viewAllCarts'),
	}),
}));

export const CartsSavedTitle = Locales((i18n) => ({
	NO_RECORDS: i18n('i18n.noRecords'),
	NO_RESULTS: i18n('i18n.emptySavedCollectionsTitle'),
	RENAME: i18n('i18n.renameCollection'),
}));

export const CART_SAVED_ACTION_LABELS = Locales((i18n) => ({
	ADD_TO_CURRENT_CART: i18n('i18n.addAllToSelection'),
	CREATE_PDF: i18n('i18n.createPDF'),
	CREATE_PDF_DOWNLOAD: i18n('i18n.download'),
	CREATE_PDF_SHARE_LINK: i18n('i18n.createLink'),
	CREATE_TMS_OBJECT_PACKAGE: i18n('i18n.createObjectPackageInTMS'),
	DELETE: i18n('i18n.deleteThisCart'),
	DOWNLOAD: i18n('i18n.download'),
	DUPLICATE: i18n('i18n.duplicateCart'),
	MANAGE_ARCHIVE: i18n('i18n.manageArchive'),
	MANAGE_ARCHIVE_ARCHIVE: i18n('i18n.archive'),
	MANAGE_ARCHIVE_UNARCHIVE: i18n('i18n.unarchive'),
	MANAGE_EXPIRATION: i18n('i18n.manageAssetExpiration'),
	MENU: i18n('i18n.share'),
	SHARE_FEED: i18n('i18n.createFeed'),
	SHARE_LINK: i18n('i18n.createLink'),
	SHARE_TEAM_ACCESS: i18n('i18n.manageTeamAccess'),
	RENAME: i18n('i18n.renameCart'),
	REMOVE_ASSET: i18n('i18n.removeFromSavedCart'),
	REMOVE_SELECTED_ASSETS: i18n('i18n.removeFromSavedCart'),
	REVIEW: i18n('i18n.review'),
	TOGGLE_FAVORITE: i18n('i18n.toggleFavorite'),
}));
